import { Flex, Heading, Text } from "@wayflyer/flyui";

type OverviewSectionProps = {
  title: string;
  description?: string;
  children: React.ReactNode;
};

export const OverviewSection = ({ title, description, children }: OverviewSectionProps) => (
  <Flex direction="column" gap="4">
    <Flex direction="column">
      <Heading size="lg" element="h2">
        {title}
      </Heading>
      {description ? <Text color="placeholder">{description}</Text> : null}
    </Flex>
    <Flex direction="column" gap="2">
      {children}
    </Flex>
  </Flex>
);
